
export default function* rootSaga() {
  yield [
  ];
}



// WEBPACK FOOTER //
// ./src/app/sagas/sagas.js